import lang from '../../../lang/index.js';
export const minimumLength = 8;
export default function zipCode() {
    return this
        .matches(/^\d{5}(-\d{4})?$/, lang().validation.zipCode);
}
//# sourceMappingURL=index.js.map